export default "__VITE_ASSET__99dcd930__"